<template>
  <main
    v-if="isAuth"
    class="main profile-page page-inside"
  >
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title">
            {{ $t(`My account`) }}
          </div>
          <div class="profile-top">
            <div class="profile-top-left">
              <img
                src="./../images/user-white.svg"
                class="img"
              >
              <div class="text">
                <div class="title small">
                  {{ name }} {{ surname }}
                </div>
                <div class="desc">
                  <b>{{ $t(`Joined:`) }}</b>
                  {{ formatDate(joined) }}
                </div>
              </div>
            </div>
            <div class="profile-top-right">
              <img
                src="./../images/walletProfile.svg"
                class="img"
              >
              <div class="text">
                <div class="title small">
                  {{ $t(`My balance`) }}
                </div>
                <div class="title">
                  <span>{{ balance }} {{ internalCurrencyName }}</span>
                </div>
              </div>
              <button
                class="button green"
                @click="openTopUpModal(0.0)"
              >
                <span>{{ $t(`Top Up`) }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="section profile-section">
        <img
          src="./../images/believe-peace.svg"
          class="img peace"
        >
        <div class="wrapper">
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="wrapper">
                <div class="profile-nav-container">
                  <ul class="profile-nav pack-list">
                    <template
                      v-for="(item, i) in profileNav"
                      :key="i"
                    >
                      <li
                        :class="['pack-list__item', { 'active': item.page === activeProfilePage }]"
                        @click="goToProfilePage(item.page)"
                      >
                        <div class="desc">
                          {{ item.title }}
                        </div>
                      </li>
                    </template>
                  </ul>
                  <li
                    class="logout-item hover-link"
                    @click="logout"
                  >
                    <img
                      src="./../images/logout.svg"
                      class="img"
                    >
                    <div class="desc">
                      {{ $t(`Log out`) }}
                    </div>
                  </li>
                </div>
                <div
                  v-if="activeProfilePage === 'contact-info'"
                  class="content personal-info"
                >
                  <div class="block">
                    <div class="block-top">
                      <div class="title small">
                        {{ $t(`Contact Information`) }}
                      </div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('First name') }}:
                          </div>
                          <input
                            v-model="name"
                            type="text"
                            :placeholder="$t('First name')"
                          >
                          <transition name="fade">
                            <div
                              v-if="errors.name && errors.name.length"
                              class="error-message"
                            >
                              {{ errors.name[0] }}
                            </div>
                          </transition>
                        </div>
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('E-mail') }}:
                          </div>
                          <input
                            v-model="email"
                            type="email"
                            :placeholder="$t('E-mail')"
                          >
                          <transition name="fade">
                            <div
                              v-if="errors.email && errors.email.length"
                              class="error-message"
                            >
                              {{ errors.email[0] }}
                            </div>
                          </transition>
                        </div>
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Last name') }}:
                          </div>
                          <input
                            v-model="surname"
                            type="text"
                            :placeholder="$t('Last name')"
                          >
                          <transition name="fade">
                            <div
                              v-if="errors.surname && errors.surname.length"
                              class="error-message"
                            >
                              {{ errors.surname[0] }}
                            </div>
                          </transition>
                        </div>
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Phone') }}:
                          </div>
                          <vue-tel-input
                            v-if="allowedCountries.length > 0"
                            v-model="phone"
                            :only-countries="allowedCountries"
                            :default-country="computedDefaultCountry"
                            :auto-default-country="false"
                            mode="international"
                            :auto-format="true"
                            :valid-characters-only="true"
                            :dropdown-options="{ 
                              showDialCodeInList: true, 
                              showDialCodeInSelection: false, 
                              showFlags: true, 
                              showSearchBox: false,
                              tabindex: 0
                            }"
                            :input-options="{ 
                              placeholder: $t('Enter phone number'),
                              disabled: allowedCountries.length === 0
                            }"
                            @on-input="onPhoneInput"
                            @blur="onPhoneBlur"
                            class="profile-phone-input"
                          />
                          <input
                            v-else
                            type="tel"
                            :placeholder="$t('Loading countries...')"
                            disabled
                            class="phone-loading-input"
                          />
                          <transition name="fade">
                            <div
                              v-if="errors.phone && errors.phone.length"
                              class="error-message"
                            >
                              {{ errors.phone[0] }}
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                    <button
                      class="button"
                      @click="updateProfileData"
                    >
                      <span>{{ $t(`Save`) }}</span>
                    </button>
                    <transition name="fade">
                      <div
                        v-if="profileUpdateErrorMessaage"
                        class="desc red"
                      >
                        {{ profileUpdateErrorMessaage }}
                      </div>
                    </transition>
                    <transition name="fade">
                      <div
                        v-if="profileUpdateSuccessMessaage"
                        class="desc green"
                      >
                        {{ profileUpdateSuccessMessaage }}
                      </div>
                    </transition>
                  </div>

                  <div class="block">
                    <div class="block-top">
                      <div class="title small">
                        {{ $t(`Address Information`) }}
                      </div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Address') }}:
                          </div>
                          <input
                            v-model="address"
                            type="text"
                            :placeholder="$t('Address')"
                          >
                          <transition name="fade">
                            <div
                              v-if="errors.address && errors.address.length"
                              class="error-message"
                            >
                              {{ errors.address[0] }}
                            </div>
                          </transition>
                        </div>

                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('City') }}:
                          </div>
                          <input
                            v-model="city"
                            type="text"
                            :placeholder="$t('City')"
                          >
                          <transition name="fade">
                            <div
                              v-if="errors.city && errors.city.length"
                              class="error-message"
                            >
                              {{ errors.city[0] }}
                            </div>
                          </transition>
                        </div>

                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Post Code') }}:
                          </div>
                          <input
                            v-model="postCode"
                            type="text"
                            :placeholder="$t('Post Code')"
                          >
                          <transition name="fade">
                            <div
                              v-if="errors.post_code && errors.post_code.length"
                              class="error-message"
                            >
                              {{ errors.post_code[0] }}
                            </div>
                          </transition>
                        </div>

                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Country') }}:
                          </div>
                          <select
                            v-model="country"
                            :class="{ 'select-placeholder-text': country == '' || country == null }"
                          >
                            <option
                              selected
                              value=""
                            >
                              {{ $t(`Country`) }}
                            </option>
                            <option
                              v-for="item in countryOptions"
                              :key="item.iso2"
                              :value="item"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                          <transition name="fade">
                            <div
                              v-if="errors.country && errors.country.length"
                              class="error-message"
                            >
                              {{ errors.country[0] }}
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                    <button
                      class="button"
                      @click="updateProfileData"
                    >
                      <span>{{ $t(`Save`) }}</span>
                    </button>
                  </div>

                  <div class="block">
                    <div class="block-top">
                      <div class="title small">
                        {{ $t(`Change Password`) }}
                      </div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Current password') }}:
                          </div>
                          <input
                            v-model="curPass"
                            type="password"
                            :placeholder="$t('Current password')"
                          >
                        </div>
                        <div class="input-container long">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('New password') }}:
                          </div>
                          <input
                            v-model="newPass"
                            type="password"
                            :placeholder="$t('New password')"
                          >
                        </div>
                        <div class="input-container long">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Confirm password') }}:
                          </div>
                          <input
                            v-model="repeatPass"
                            type="password"
                            :placeholder="$t('Confirm password')"
                          >
                        </div>
                        <div class="pass-rules">
                          <div class="desc bold">
                            {{ $t('Password must contain:') }}
                          </div>
                          <div class="desc">
                            {{
                              $t(`At least 6 characters, 1 upper case letter (A-Z), 1 lower case letter
                            (a-z), 1 number (0-9)`)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      class="button"
                      @click="updatePassword"
                    >
                      <span>{{ $t(`UPDATE`) }}</span>
                    </button>
                    <transition name="fade">
                      <div
                        v-if="passUpdateErrorMessaage"
                        class="desc red"
                      >
                        {{ passUpdateErrorMessaage }}
                      </div>
                    </transition>
                    <transition name="fade">
                      <div
                        v-if="passUpdateSuccessMessaage"
                        class="desc green"
                      >
                        {{ passUpdateSuccessMessaage }}
                      </div>
                    </transition>
                  </div>

                  <div class="block">
                    <div class="block-top">
                      <div class="title small">
                        {{ $t(`Referral code`) }}
                      </div>
                      <div class="fields">
                        <div class="input-container">
                          <div class="desc">
                            <span class="red">*</span> {{ $t('Referral code') }}:
                          </div>
                          <input
                            v-model="referralCode"
                            type="text"
                            :placeholder="$t('Referral code')"
                          >
                        </div>
                      </div>
                    </div>
                    <button
                      class="button"
                      @click="updateReferralCode"
                    >
                      <span>{{ $t(`UPDATE`) }}</span>
                    </button>
                  </div>
                </div>
                <div
                  v-if="activeProfilePage === 'promt-history'"
                  class="content profile-table"
                >
                  <div class="profile-table-wrapper profile-form-wrapper">
                    <div class="title small">
                      {{ $t(`My promptstorms`) }}
                    </div>
                    <div class="table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{{ $t(`Title`) }}</td>
                            <td class="prompt-col">{{ $t(`Prompt`) }}</td>
                            <td class="actions-col">{{ $t(`Actions`) }}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, i) in promtHistory"
                            :key="i"
                          >
                            <td>{{ item.title }}</td>
                            <td>
                              <div class="prompt-text line-clamp" v-html="item.prompt"></div>
                            </td>
                            <td>
                              <div class="prompt-actions-cell">
                                <button class="action-btn-small" @click="copyPrompt(item.prompt)" :title="$t('Copy')">
                                  <span>{{ $t('Copy') }}</span>
                                </button>
                                <button class="action-btn-small" @click="downloadPrompt(item)" :title="$t('Download')">
                                  <span>{{ $t('Download') }}</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  v-if="activeProfilePage === 'order-history'"
                  class="content profile-table"
                >
                  <div class="profile-table-wrapper profile-form-wrapper">
                    <div class="title small">
                      {{ $t(`Order history`) }}
                    </div>
                    <div class="table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{{ $t(`Date/time`) }}</td>
                            <td>{{ $t(`Title`) }}</td>
                            <td>{{ $t(`Status`) }}</td>
                            <td>{{ $t(`Total`) }}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, i) in orderHistory"
                            :key="i"
                          >
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>{{ item.title }}</td>
                            <td>
                              <div :class="['status', { 'green': item.status?.toLowerCase() === 'success' }]">
                                {{ item.status }}
                              </div>
                            </td>
                            <td><b>{{ item.sum }}&nbsp;{{ item.currency }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  v-if="activeProfilePage === 'deposit-history'"
                  class="content profile-table"
                >
                  <div class="profile-table-wrapper profile-form-wrapper">
                    <div class="title small">
                      {{ $t(`Deposit history`) }}
                    </div>
                    <div class="table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>{{ $t(`Date/time`) }}</td>
                            <td>{{ $t(`Status`) }}</td>
                            <td>{{ $t(`Total`) }}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, i) in depositHistory"
                            :key="i"
                          >
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>
                              <div :class="['status', { 'green': item.status?.toLowerCase() === 'success' }]">
                                {{ item.status }}
                              </div>
                            </td>
                            <td><b>{{ item.sum }}&nbsp;{{ item.currency }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ConfirmationModal
      :visible="showDisclaimer"
      :title="$t('Warning')"
      :message="disclaimerMessage"
      :confirm-text="$t('Proceed')"
      :cancel-text="$t('Cancel')"
      @confirm="confirmReferralCodeUpdate"
      @close="cancelReferralCodeUpdate"
    />
  </main>
</template>
<script>
import {defineComponent} from 'vue';

import {mapGetters} from "vuex";
import ConfirmationModal from "../components/ConfirmationModal.vue";

export default defineComponent({
  name: 'Profile',
  inject: ['openSignInModal', 'formatDate', 'internalCurrencyName', 'openTopUpModal', 'logout', 'orderHistory', 'promtHistory', 'depositHistory'],

  components: {
    ConfirmationModal
  },
  props: ['currency'],

  data: function () {
    return {
      email: '',
      name: '',
      surname: '',
      phone: '',
      joined: '',
      balance: '',
      profileUpdateSuccessMessaage: '',
      profileUpdateErrorMessaage: '',
      curPass: '',
      newPass: '',
      repeatPass: '',
      passUpdateSuccessMessaage: '',
      passUpdateErrorMessaage: '',
      activeProfilePage: '',
      profileNav: [
        {
          page: 'promt-history',
          title: 'My promptstorms'
        },
        {
          page: 'contact-info',
          title: 'Contact Information'
        },
        {
          page: 'deposit-history',
          title: 'Deposit history'
        },
        {
          page: 'order-history',
          title: 'Order history'
        }
      ],
      phoneFull: "",
      countryOptions: [],
      countryOptionsIso: [],
      userCountryId: '',

      country: '',
      city: '',
      address: '',
      postCode: '',
      errors: {},

      referralCode: '',
      showDisclaimer: false,
      disclaimerMessage: '',
      currentDiscount: 0,
      newDiscount: 0,
      currentPhoneObject: null,
    }
  },

  watch: {
    currency: function () {
      this.getProfile();
    },
    promtHistory: {
      handler(newVal) {
        if (newVal && newVal.length) {
        }
      },
      immediate: true
    }
  },

  mounted() {
    this.activeProfilePage = this.$route.params.page;
    Promise.all([this.getProfile(), this.getCountries()])
        .then(() => {
          this.setDefaultCountry();
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.openSignInModal();
          } else {
            console.error(err);
          }
        });
  },

  methods: {
    getCountries() {
      return this.$http.get('countries')
          .then((res) => {
            this.countryOptions = res.data.payload;
            this.countryOptionsIso = res.data.payload.map(obj => obj.iso2);
          });
    },
    getProfile() {
      return this.$http.get('user/profile')
          .then((res) => {
            if (res.status == 200) {
              this.email = res.data.email;
              this.name = res.data.name;
              this.surname = res.data.surname;
              this.phone = res.data.phone;
              this.phoneCountryCode = res.data.phone_country_code;
              this.address = res.data.address;
              this.postCode = res.data.post_code;
              this.city = res.data.city;
              this.userCountry = res.data.country;
              this.joined = res.data.created_at;
              this.balance = res.data.balance;
              this.referralCode = res.data.referral_code;
            }
          });
    },
    setDefaultCountry() {
      if (this.userCountry && this.countryOptions.length) {
        // Try to match by iso2 first (from profile country.iso), then by id
        const foundCountry = this.countryOptions.find(
          item => item.iso2 == this.userCountry.iso || item.id == this.userCountry.id
        );
        if (foundCountry) {
          this.country = foundCountry;
        }
      }
    },
    phoneDataUpdate(number, phoneObject) {
      this.phoneFull = phoneObject.formattedNumber || number;
    },
    onPhoneInput(number, phoneObject) {
      this.phone = number;
      this.phoneFull = phoneObject?.formattedNumber || number;
      
      // Clear any existing phone errors when user is typing
      if (this.errors.phone) {
        this.errors.phone = [];
      }
      
      // Store the phone object for later validation
      this.currentPhoneObject = phoneObject;
    },
    onPhoneBlur() {
      // Validate when user leaves the phone input field
      this.validateCurrentPhone();
    },
    validateCurrentPhone() {
      if (!this.currentPhoneObject) {
        return;
      }
      
      const phoneObject = this.currentPhoneObject;
      
      // Only validate if user has entered something that looks like it could be a complete number
      if (phoneObject && phoneObject.countryCode && this.phone && this.phone.length > 5) {
        const countryCode = phoneObject.countryCode.toLowerCase();
        
        // Check if country is supported
        const isSupported = this.countryOptionsIso && this.countryOptionsIso.length > 0 
          ? this.countryOptionsIso.some(iso => iso && iso.toLowerCase() === countryCode)
          : false;
        
        if (!isSupported) {
          this.errors.phone = ['This country is not supported'];
          return false;
        }
        
        // Check if phone number is valid
        if (!phoneObject.valid) {
          this.errors.phone = ['Please enter a valid phone number'];
          return false;
        }
      }
      
      return true;
    },
    validatePhone(phoneObject) {
      // Check if phoneObject exists and has required properties
      if (!phoneObject) {
        return false;
      }
      
      // Check if the country is supported by our API
      if (phoneObject.countryCode) {
        const countryCode = phoneObject.countryCode.toLowerCase();
        const isSupported = this.countryOptionsIso && this.countryOptionsIso.length > 0 
          ? this.countryOptionsIso.some(iso => iso && iso.toLowerCase() === countryCode)
          : false;
        
        if (!isSupported) {
          return false;
        }
      }
      return phoneObject.valid || false;
    },
    updateProfileData() {
      // Validate phone number before submission
      if (this.errors.phone && this.errors.phone.length > 0) {
        this.$toast?.error?.('Please fix phone number errors before saving');
        return;
      }
      
      // Check if phone is empty
      if (!this.phone || !this.phoneFull) {
        this.errors.phone = ['Phone number is required'];
        return;
      }
      
      let profileData = {
        "email": this.email,
        "name": this.name,
        "phone": this.phoneFull,
        "surname": this.surname,
        "address": this.address,
        'city': this.city,
        'post_code': this.postCode,
        "country_id": this.country ? this.country?.id : null
      }
      this.$http.put('user/profile', profileData)
          .then((res) => {
            if (res.data.status == "OK") {
              this.errors = {}
              this.$toast.success('Profile successfully updated!');
            }
          })
          .catch((res) => {
            if (res.response?.status === 401) {
              this.openSignInModal();
            }
            this.errors = res.response?.data?.errors || {};

            clearTimeout(this.timeoutId); // cancel previous timeout
            this.timeoutId = setTimeout(() => {
              // this.profileUpdateErrorMessaage = '';
              this.errors = {};
            }, 3000);
          })
    },
    updatePassword() {
      let passwordList = {
        "cur_password": this.curPass,
        "new_password": this.newPass,
        "repeat_password": this.repeatPass
      }
      this.$http.post('user/change-password', passwordList)
          .then((res) => {
            if (res.data.status == "OK") {
              this.passUpdateSuccessMessaage = 'Success';
              this.curPass = '',
                  this.newPass = '',
                  this.repeatPass = '';
              setTimeout(() => {
                this.passUpdateSuccessMessaage = '';
              }, 3000);
            }
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.openSignInModal();
            }
            this.passUpdateErrorMessaage = res.response.data.message;
            setTimeout(() => {
              this.passUpdateErrorMessaage = '';
            }, 3000);
          })
    },
    updateReferralCode() {
      this.$http.put('user/referral-code', {referral_code: this.referralCode, confirmed: false})
          .then((res) => {
            console.log(res.data.status);
            if (res.data.status === "OK") {
              this.handleSuccessfulUpdate(res.data.message);
            } else if (res.data.status === "WARNING") {
              this.showWarningDisclaimer(res.data);
            }
          })
          .catch(this.handleUpdateError);
    },
    confirmReferralCodeUpdate() {
      this.$http.put('user/referral-code', {
        referral_code: this.referralCode,
        confirmed: true
      })
          .then((res) => {
            if (res.data.status === "OK") {
              this.handleSuccessfulUpdate(res.data.message);
            }
          })
          .catch(this.handleUpdateError);
      this.showDisclaimer = false;
    },
    cancelReferralCodeUpdate() {
      this.showDisclaimer = false;
    },
    handleSuccessfulUpdate(message) {
      this.$toast.success(message);
    },
    showWarningDisclaimer(data) {
      this.showDisclaimer = true;
      this.disclaimerMessage = `${data.message}<br><br>Current discount: ${data.current_discount_percentage}%<br>New discount: ${data.new_discount_percentage}%`;
      this.currentDiscount = data.current_discount_percentage;
      this.newDiscount = data.new_discount_percentage;
    },
    handleUpdateError(error) {
      if (error.response.status === 401) {
        this.openSignInModal();
      }
      this.$toast.error(error.response.data.message || 'An error occurred', {timeout: 3000});
    },
    goToProfilePage(page) {
      this.$router.push({path: '/profile/' + page});
      this.activeProfilePage = page;
    },
    copyPrompt(text) {
      const el = document.createElement('textarea');
      el.value = text.replace(/<[^>]*>/g, '');
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$toast.success('Prompt copied to clipboard!');
    },
    downloadPrompt(item) {
      const element = document.createElement('a');
      const text = item.prompt.replace(/<[^>]*>/g, '');
      const file = new Blob([text], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = `${item.title.replace(/\s+/g, '_')}_prompt.txt`;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  },

  computed: {
    ...mapGetters('user', ['isAuth']),
    getDefaultCountryIso() {
      return this.phoneCountryCode || this.countryOptionsIso[0];
    },
    allowedCountries() {
      return this.countryOptionsIso && this.countryOptionsIso.length > 0 
        ? this.countryOptionsIso.map(iso => iso.toLowerCase()) 
        : [];
    },
    computedDefaultCountry() {
      if (this.allowedCountries.length > 0) {
        return this.phoneCountryCode 
          ? this.phoneCountryCode.toLowerCase() 
          : this.allowedCountries[0];
      }
      return null;
    },
  },
});
</script>

<style scoped>
.prompt-col {
  width: 60%;
}

.actions-col {
  width: 140px;
  text-align: center;
  vertical-align: middle;
}

.prompt-text {
  font-size: 15px;
  line-height: 1.6;
  color: #02150C;
  text-align: left;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.prompt-actions-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.action-btn-small {
  width: 100%;
  max-width: 110px;
  padding: 6px 12px;
  border-radius: 20px;
  background: #1B9B65;
  color: #fff;
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Poppins', sans-serif;
}

.action-btn-small:hover {
  opacity: 0.8;
  transform: translateY(-1px);
}

.action-btn-small:active {
  transform: translateY(0);
}
</style>

